/* eslint-disable @typescript-eslint/naming-convention */
export enum NavUrls {
  ASSIGNFIELDTOCUSTOMER = 'assign-field-to-customer',
  ACTIVITY = 'activity',
  LOGIN = 'login',
  CUSTOMERS = 'customers',
  ADDEDITCUSTOMER = 'add-edit-customer',
  DARSHBOARD = 'dashboard',
  EMPLOYEES = 'employees',
  ADDEDITEMPLOYEE = 'add-edit-employee',
  FIELD = 'field',
  FIELDS = 'fields',
  ADDEDITFIELDGEOMETRY = 'add-edit-field-geometry',
  ADDEDITFIELDINFORMATION = 'add-edit-field-information',
  MACHINES = 'machines',
  MACHINEDETAILS = 'machinedetails',
  ADDMACHINE = 'addmachine',
  ROOT = '/',
  REGISTER = 'register',
  ACCOUNT_CONFIRM = 'account-confirm',
  JOBS = 'jobs',
  JOB_DETAILS = 'job-details',
  LOST_PASSWORD = 'lost-password',
  LOCATION = 'location',
  LOCATIONS = 'locations',
  ADDEDITLOCATIONGEOMETRY = 'add-edit-location-geometry',
  ADDEDITLOCATIONINFORMATION = 'add-edit-location-information',
  DASHBOARD = 'dashboard',
  DASHBOARD_DASH = 'dash',
  DASHBOARD_MAP = 'map',
  DASHBOARD_WIDGETS = 'widgets',
  IMPLEMENTS = 'implements',
  ADDIMPLEMENT = 'addimplement',
}
